/*
 * Schedule Meeting forms — native date + time picker sync.
 *
 * The two Schedule Meeting forms on /pages/build-your-product POST to
 * Zoho Forms (TestFormMeetingSchedule). Zoho expects:
 *   - DateTime_date     in DD-Mon-YYYY format  (e.g. "25-May-2026")
 *   - DateTime_hours    in 12-hour HH (01..12)
 *   - DateTime_minutes  in MM (00..59)
 *   - DateTime_meridiem AM or PM
 *
 * Visible UI uses native HTML5 <input type="date"> + <input type="time">
 * (calendar + clock pickers — best UX especially on mobile). This script
 * syncs the visible picker values into the hidden Zoho-named fields on
 * change, so the form submission shape is unchanged from Zoho's
 * perspective. GTM triggers keyed on form action/id/name continue to fire.
 *
 * Loaded conditionally from layout/theme.liquid for
 * page.handle == 'build-your-product'.
 */
(function () {
  'use strict';

  var MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

  function pad2(n) {
    n = String(n);
    return n.length < 2 ? '0' + n : n;
  }

  function todayIsoDate() {
    var d = new Date();
    return d.getFullYear() + '-' + pad2(d.getMonth() + 1) + '-' + pad2(d.getDate());
  }

  function wireUpForm(form) {
    var dateDisplay = form.querySelector('.meeting-date-display');
    var timeDisplay = form.querySelector('.meeting-time-display');
    var dateHidden = form.querySelector('input[name="DateTime_date"]');
    var hoursHidden = form.querySelector('select[name="DateTime_hours"]');
    var minutesHidden = form.querySelector('select[name="DateTime_minutes"]');
    var meridiemHidden = form.querySelector('select[name="DateTime_meridiem"]');

    if (!dateDisplay || !timeDisplay || !dateHidden || !hoursHidden || !minutesHidden || !meridiemHidden) {
      return; // form structure not as expected — skip silently
    }

    // Restrict date selection to today onwards.
    dateDisplay.setAttribute('min', todayIsoDate());

    dateDisplay.addEventListener('change', function () {
      var v = this.value; // YYYY-MM-DD
      if (!v) {
        dateHidden.value = '';
        return;
      }
      var parts = v.split('-');
      var year = parseInt(parts[0], 10);
      var month = parseInt(parts[1], 10);
      var day = parseInt(parts[2], 10);
      if (!year || !month || !day) {
        dateHidden.value = '';
        return;
      }
      // DD-Mon-YYYY — the format Zoho expects (matches the old placeholder)
      dateHidden.value = pad2(day) + '-' + MONTHS[month - 1] + '-' + year;
    });

    timeDisplay.addEventListener('change', function () {
      var v = this.value; // HH:MM (24-hour)
      if (!v) {
        hoursHidden.value = '';
        minutesHidden.value = '';
        meridiemHidden.value = '';
        return;
      }
      var parts = v.split(':');
      var h24 = parseInt(parts[0], 10);
      var m = parseInt(parts[1], 10);
      if (isNaN(h24) || isNaN(m)) {
        hoursHidden.value = '';
        minutesHidden.value = '';
        meridiemHidden.value = '';
        return;
      }
      var meridiem = h24 >= 12 ? 'PM' : 'AM';
      var h12 = h24 % 12;
      if (h12 === 0) h12 = 12;
      hoursHidden.value = pad2(h12);
      minutesHidden.value = pad2(m);
      meridiemHidden.value = meridiem;
    });

    // Defensive: if the form is submitted before the visible pickers fired
    // a 'change' event (some browsers don't fire change on initial typing),
    // re-trigger the conversion on submit so the hidden fields are filled.
    form.addEventListener('submit', function () {
      if (dateDisplay.value && !dateHidden.value) {
        dateDisplay.dispatchEvent(new Event('change'));
      }
      if (timeDisplay.value && !hoursHidden.value) {
        timeDisplay.dispatchEvent(new Event('change'));
      }
    });
  }

  function init() {
    var forms = document.querySelectorAll('form[action*="TestFormMeetingSchedule"]');
    for (var i = 0; i < forms.length; i++) {
      wireUpForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
